var _style, _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133 133",
    style: {
      enableBackground: "new 0 0 133 133"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF0F3;}\n\t.st1{fill:#E5F2FF;}\n\t.st2{fill:none;}\n\t.st3{fill:none;stroke:#5DA6FF;}\n\t.st4{fill:none;stroke:#A8D5FF;stroke-width:3;}\n\t.st5{fill:none;stroke:#001C4A;stroke-width:2;}\n\t.st6{fill:#001C4A;}\n\t.st7{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11-2",
    className: "st0",
    cx: 65,
    cy: 66,
    r: 43
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    className: "st1",
    d: "M65,23c23.7,0,43,19.3,43,43s-19.3,43-43,43S22,89.7,22,66S41.3,23,65,23z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 66.5,
    cy: 66.5,
    r: 49.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 66.5,
    cy: 66.5,
    r: 49
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 66.5,
    cy: 66.5,
    r: 59.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 66.5,
    cy: 66.5,
    r: 58
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 66.5,
    cy: 66.5,
    r: 66.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 66.5,
    cy: 66.5,
    r: 65.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40_00000095300614585611560660000006743191558943124406_",
    className: "st6",
    d: "M49.5,66.5c0-9.4,7.6-17,17-17s17,7.6,17,17 s-7.6,17-17,17S49.5,75.9,49.5,66.5L49.5,66.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    className: "st7",
    d: "M73.5,66.2l-10.4-6c-0.1-0.1-0.3,0-0.4,0.1c0,0,0,0.1,0,0.2v12.1c0,0.2,0.1,0.3,0.3,0.3 c0.1,0,0.1,0,0.2,0l10.4-6c0.1-0.1,0.2-0.3,0.1-0.4C73.6,66.3,73.6,66.3,73.5,66.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMob);
export default __webpack_public_path__ + "static/media/play-mob.4444d55d4f81fd4afe7d543782102dab.svg";
export { ForwardRef as ReactComponent };